import {
  getUserMe,
  GetUserMeData,
  GetUserMeResponse,
} from '@data-access/connect/tc-user';
import type { Client } from '@data-access/connect/tc-issue-management';
import { useQuery, UseQueryResult, QueryClient } from '@tanstack/solid-query';

// Constants for cache times (in milliseconds)
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const USER_DATA_STALE_TIME = 300000; // 5 minutes

export class UserApiService {
  constructor(
    private readonly client: Client,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS6138: Reserved for future use
    private readonly queryClient: QueryClient
  ) {}

  // Query for getting current user details
  public getUserMeQuery(
    options?: Partial<GetUserMeData>
  ): UseQueryResult<GetUserMeResponse, Error> {
    return useQuery(() => ({
      queryKey: ['users', 'me', options],
      queryFn: async (): Promise<GetUserMeResponse> => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const response = await getUserMe({
          client: this.client as any,
          ...options,
        });

        if (response.error) {
          throw new Error('Failed to get current user');
        }

        return response.data!;
      },
      staleTime: USER_DATA_STALE_TIME, // 5 minutes - user data doesn't change frequently
    }));
  }
}
